import { render, staticRenderFns } from "./InfoProduto.vue?vue&type=template&id=9d92372c&"
import script from "./InfoProduto.vue?vue&type=script&lang=js&"
export * from "./InfoProduto.vue?vue&type=script&lang=js&"
import style0 from "./InfoProduto.vue?vue&type=style&index=0&id=9d92372c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports